var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center grey--text"},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-information-slab-circle-outline")]),_c('div',{staticClass:"mt-2 subtitle-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }